import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Wxlogin from '@/views/Wxlogin'
import Register from '@/views/Register'
import Page from '@/views/Page'
import Test from '@/views/Test'
import Changepassword from '@/views/Changepassword'
import Forgetpassword from '@/views/Forgetpassword'
import Updatepassword from '@/views/Updatepassword'
import Jointeam from '@/views/Jointeam'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Login
    // },
    {
      path: '/login.html',
      name: 'login',
      component: Login
    },
    {
      path: '/wxlogin.html',
      name: 'wxlogin',
      component: Wxlogin
    },
    {
      path: '/signup.html',
      name: 'register',
      component: Register
    },
    {
      path: '/page/:pageId',
      name: 'page',
      component: Page
    },
    {
      path: '/changepassword.html',
      name: 'changepassword',
      component: Changepassword
    },
    {
      path: '/updatepassword.html',
      name: 'updatepassword',
      component: Updatepassword
    },
    {
      path: '/forgetpassword.html',
      name: 'forgetpassword',
      component: Forgetpassword
    },
    {
      path: '/test.html',
      name: 'test',
      component: Test
    },
     {
      path: '/jointeam.html',
      name: 'jointeam',
      component: Jointeam
    },
  ]
})
